import type { ComponentWithoutHOCProps } from 'common/types/component';
import type { ReactElement } from 'react';
import { Redirect } from 'react-router';
import { withAuthLayout } from '../login/authLayout.page';
import { featureFlags } from 'common/featureFlags/featureFlags';

const _OktaPostLogoutCallback = (): ReactElement => {
    const switchUserReturnUrl = localStorage.getItem('postLoginRedirectUrl');
    if (featureFlags.fxIntegration && switchUserReturnUrl) {
        localStorage.removeItem('postLoginRedirectUrl');

        return <Redirect to={switchUserReturnUrl} />;
    }

    return <Redirect to="/login" />;
};

const OktaPostLogoutCallback: ComponentWithoutHOCProps<null> = withAuthLayout(_OktaPostLogoutCallback);
export default OktaPostLogoutCallback;
